<template>
    <div>

        <div>
            <van-button type="primary" @click="refreshPage">刷新页面1</van-button>
        </div>

        <div class="mt10">
            <van-button type="primary" @click="outputPageURL">输出页面URL</van-button>
        </div>

        <div class="mt10">
            <van-button type="primary" @click="jumpTologin">跳转微信登录</van-button>
        </div>


    
    </div>

</template>

<script>
export default {
    name: 'billingInfo',
    props: [],
    components: {},
    data: function () {
        return {}
    },
    setup() {

    },

    mounted: function () {},
    methods: {
        refreshPage() {
      // 刷新页面的方法
        location.reload();
        },
        outputPageURL() {
        // 输出页面URL的方法
            const currentURL = window.location.href;
            console.log("当前页面URL:", currentURL);
        },
        jumpTologin(){
            window.location.href = 'http://corp-hisdev.ygjkq.com:18000/personalCenterPage?jump=wx&appid=ww82e51ece6311fcc5&redirect_uri=http://corp-hisdev.ygjkq.com:18000/#/personalCenterPage&scope=snsapi_privateinfo&agentid=1000006&state=1000006ww82e51ece6311fcc5'
        }
    }
}
</script>

<style>

</style>
